// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__26XPL","grid-3":"Grid_grid-3__2rnX7","grid-5":"Grid_grid-5__2gpQd","grid-7":"Grid_grid-7__1FjyI","outcome":"Grid_outcome__2ZW01"};